import { ChangeDetectorRef, Component, Inject, OnInit } from "@angular/core";
import { Wrapper } from "../wrapper.component";
import { JoiEvent } from "globals/store/events.data";
import { ManageWrapperComponent, Tab, TabGroup } from "../../modules/manage/manage-wrapper.component";
import { BrandOption, BrandOptionTabNames, BrandOptions, BrandType, BrandingData, BrandingIds, BrandingProps, BrandingSelectData } from "globals/store/publish.data";
import {MatDialogRef,MAT_DIALOG_DATA } from "@angular/material/dialog";
import { JoiAccount } from "globals/store/accounts.data";
import { brandDataReselector } from "../../store/reselectors/publish.reselector";
import { PublishInfo } from "globals/store/share.data";
import { JoiAppInfo } from "globals/store/app.data";
import { jsonCopyObject } from "globals/helpers/helpers";
import { TipTextComponent } from "../misc/tip-text.component";
import { BrandImageEditorComponent } from "./brand-image-editor.component";
import { TemplateEditorComponent } from "./template-editor.component";
import { BrandSocialEditorComponent } from "./brand-social-editor.component";
import { BrandFooterLinksEditorComponent } from "./brand-footer-links-editor.component";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";

@Component({
    selector: 'manage-branding',
    templateUrl: './manage-branding.html',
    styleUrls: ['../../modules/manage/manage-dialogs.scss'],
    styles: [`
  tip-text { display: block; margin-bottom: 20px; }    
`],
    standalone: true,
    imports: [ManageWrapperComponent, MatButtonModule, BrandFooterLinksEditorComponent, CommonModule, TemplateEditorComponent, BrandSocialEditorComponent, TipTextComponent, BrandImageEditorComponent],
})

export class ManageBrandingComponent extends Wrapper<ManageBrandingComponent> implements OnInit {
  _file = 'manage-branding'
  labels;
  tabs = BrandOptions
  event: JoiEvent
  tabGroups: TabGroup<BrandOption>[] = [{ tabs: [
    { id: 'template', name: BrandOptionTabNames.template },
    { id: 'header', name: BrandOptionTabNames.header },
    { id: 'social' , name: BrandOptionTabNames.social },
    { id: 'footerLinks', name: BrandOptionTabNames.footerLinks},
    { id: 'footer', name: BrandOptionTabNames.footer },
  ]}]
  selectedTab: Tab
  brandingData: BrandingData
  account: Partial<JoiAccount>
  publishInfo: PublishInfo
  appInfo: JoiAppInfo

  ngOnInit() {
    if (this.data.outsideEvent) this.subProp(this.store.select('accounts', 'entities', this.data.accountId), 'account')
    else this.subProp(this.store.select('accounts', 'account'), 'account') 

    if (this.data.publishId) this.subProp(this.store.select('shareables', 'publish', this.data.publishId), 'publishInfo')
    if (this.data.appId) this.subProp(this.store.select('apps', 'entities', this.data.appId), 'appInfo')
    this.subProp(this.store.select('events', 'event'), 'event')

    const brandingSelectData: BrandingSelectData = {
      type: this.data.type,
      publishId: this.data.publishId,
      appId: this.data.appId,
      accountId: this.data.accountId,
      eventListId: this.data.eventListId,
    }
    this.selectProp(brandDataReselector, brandingSelectData, 'brandingData')
  }

  constructor(
    public dialogRef: MatDialogRef<ManageBrandingComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: ManageBrandingData,
    public changeDetectorRef: ChangeDetectorRef
    ) {
    super()
    this.selectedTab = this.tabGroups[0].tabs.find(t => t.id === data.selectedTab)
    if (data.type === 'forms') this.tabGroups[0].tabs = this.tabGroups[0].tabs.filter(t => t.id !== 'footerLinks')
  }


  select(id: string, key: keyof BrandingIds) {
    console.log({ id, key })
    if (typeof id !== 'string' && id !== null) return

    switch (this.data.type) {
      case 'forms': 
        this.eventService.updateEvent(this.event.eventId, { [key]: id })
        break
      case 'publish':
        this.publishInfo[key] = id
        console.log({ publishInfo: this.publishInfo })
        this.sharePublishService.upsertPublishInfo(this.publishInfo)
        break
      case 'list':
        const eventListInfo = this.account.eventListInfos[this.data.eventListId]
        eventListInfo[key] = id
        this.accountService.updateEventListInfo(this.data.accountId, eventListInfo)
        break
      case 'app':
        const appInfo = jsonCopyObject(this.appInfo)
        appInfo[key] = id
        this.appService.updateAppInfo(appInfo)         
      default:
        console.log("NO HANDLING FOR SELECT IN TYPE: " + this.data.type) 
        break
    }
  }

  setAsAccountDefault(id: string, key: keyof BrandingProps) {
    
    const update = { [key]: id }
    console.log({ id, key, update })

    this.accountService.updateAccount(this.account.id, update, { file: 'template-editor.component.ts', function: 'setAccountDefaultTemplateId', error: new Error(), message: 'There was an error changing the default template Id' })
  }

  exit() {
    this.dialogRef.close()
  }

  changeTab(tab) {
    this.selectedTab = tab
  }

}

export interface ManageBrandingData {
  selectedTab: BrandOption
  type: BrandType
  accountId?: string
  publishId?: string
  eventListId?: string
  appId?: string
  outsideEvent?: boolean
  onAccount: boolean
}